export function currentSalaryPeriod(date = new Date()) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
}

export function parseSalaryPeriod(value) {
    const s = String(value || "").trim();
    if (!/^\d{4}-(0[1-9]|1[0-2])$/.test(s)) return null;
    return s;
}

const MONTH_NAMES = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export function formatSalaryPeriodLabel(period) {
    const p = parseSalaryPeriod(period);
    if (!p) return String(period || "");
    const [ys, ms] = p.split("-");
    const m = parseInt(ms, 10);
    return `${MONTH_NAMES[m - 1]} ${ys}`;
}

export function recentSalaryPeriodOptions(count = 12, fromDate = new Date()) {
    const out = [];
    const d = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
    for (let i = 0; i < count; i += 1) {
        const value = currentSalaryPeriod(d);
        out.push({ value, label: formatSalaryPeriodLabel(value) });
        d.setMonth(d.getMonth() - 1);
    }
    return out;
}

export function resolveSalaryStatusForPeriod(teacher, period) {
    const p = parseSalaryPeriod(period) || currentSalaryPeriod();
    const lastPaid = String(teacher?.salaryLastPaidPeriod || "").trim();
    const raw = String(teacher?.salaryPaymentStatus || "Unpaid");

    if (lastPaid === p && raw === "Paid") {
        return { status: "Paid", period: p };
    }
    if (raw === "Pending") {
        return { status: "Pending", period: p };
    }
    return { status: "Unpaid", period: p };
}
